import { mapState } from 'vuex';
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    program: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      initConfig: state => state.initConfig,
      loginInfo: state => state.loginInfo
    })
  },
  data() {
    return {
      selectValue: '',
      options: []
    };
  },
  methods: {
    getList() {
      if (this.program === 'Production') {
        this.getProducerList();
      } else if (this.program === 'Master Control') {
        this.getMasterControlList();
      }
    },
    getProducerList() {
      this.axios.get(`${this.initConfig.urlInfo.getwayProducer}/feign/getRunningProductionsInfo/${this.loginInfo.id}`)
      // .get(`/newppapi/feign/getRunningProductionsInfo/${this.loginInfo.id}`)
      .then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.options = result;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getMasterControlList() {
      const parmas = {
        condition: '',
        pageNum: 1,
        pageSize: 20,
        userId: this.loginInfo.id,
        type: 1
      };
      this.axios.post(`${this.initConfig.urlInfo.channel}/tvu-playout/program/getChannelList`, parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.options = result.list;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    returnValue(item) {
      if (this.program === 'Production' || this.program === 'Master Control') {
        return item.id;
      }
    },
    returnLabel(item, text) {
      return this.program === 'Production' ? item.name + (text ? ' ' + '(ID: ' + item.id + ')' : '') : item.channelName + (text ? ' ' + '(ID: ' + item.id + ')' : '');
    },
    jumpPage() {
      if (this.program === 'Production') {
        window.open(`${location.href}preview?program=Production&programId=${this.selectValue}`, '_blank');
      } else if (this.program === 'Master Control') {
        window.open(`${location.href}preview?program=Master Control&programId=${this.selectValue}`, '_blank');
      }
      this.info.visiable = false;
    },
    cancel() {
      this.selectValue = '';
      this.info.visiable = false;
    }
  }
};